// extracted by mini-css-extract-plugin
module.exports = {"container":"sLx54hpdKbrsE1mSauw_0","icon":"_3aVqsKwyK57JpkU8gZ3e8W","inactive":"_13q4r9OMfVctC9gdkGLCch","delete-icon":"_2R3Z2kHdeeJFZGmK1oI01_"};